import useSWR from 'swr';
import { Avatar, Flex, Box } from '@vibe/core';
import { RelativeTime } from '@gorilla/ui/src/components/RelativeTime';
import { userBatchResolver } from '../hooks/use-user';

type CreatedByProps = {
  userId: number;
  time: number;
  userAvatar: boolean;
};

export default function CreatedBy({ userId, time, userAvatar }: CreatedByProps) {
  const {
    data: user,
    isLoading,
    error,
  } = useSWR(`/created-by/${userId}`, async () => userBatchResolver.resolveItem(userId), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error || !user) {
    return <div>Failed to load user</div>;
  }

  return (
    <>
      {userAvatar ? (
        <>
          <Avatar type="img" size="medium" withoutBorder={true} src={user.photo_small} />
        </>
      ) : (
        <>
          <Box>
            <Flex gap="small">
              <div
                style={{
                  fontSize: '12px',
                  color: '#afb0bd',
                }}
              >
                Created <RelativeTime date={time} /> by {user.name}
              </div>
            </Flex>
          </Box>
        </>
      )}
    </>
  );
}
